const inIframe = (window === window.parent || window.opener) ? false : true;

 if (inIframe) {
    document.oncontextmenu = (event) => {
        if(event.preventDefault != undefined)
            event.preventDefault();
        if(event.stopPropagation != undefined)
            event.stopPropagation();
    }
}